import { z } from 'zod';
import { LIMITS } from './project.js';
/**
 * Narración (apartado opcional). El director de texto propone una locución por
 * escena ajustada a su duración; el usuario la edita, la guarda en las escenas
 * y genera el audio con el TTS del núcleo.
 */
/** Voces del TTS de OpenAI con nombre legible. Lista cerrada, como en ai-core. */
export const TTS_VOICES = {
    alloy: 'Alloy (neutra)',
    ash: 'Ash (grave, serena)',
    ballad: 'Ballad (cálida)',
    coral: 'Coral (clara, cercana)',
    echo: 'Echo (masculina, firme)',
    fable: 'Fable (narrativa)',
    nova: 'Nova (femenina, enérgica)',
    onyx: 'Onyx (grave, profunda)',
    sage: 'Sage (suave)',
    shimmer: 'Shimmer (brillante)',
    verse: 'Verse (expresiva)',
    marin: 'Marin',
    cedar: 'Cedar',
};
export const ttsVoiceSchema = z.enum(Object.keys(TTS_VOICES));
/** Palabras por segundo de una locución pausada en español. */
export const WORDS_PER_SECOND = 2.3;
export const NARRATION_SCRIPT_SCHEMA_VERSION = 1;
export const narrationScriptSchema = z.object({
    schemaVersion: z.literal(NARRATION_SCRIPT_SCHEMA_VERSION),
    /** Indicación de entrega para toda la pieza (tono, ritmo), en el idioma del usuario. */
    deliveryStyle: z.string().min(1).max(300),
    scenes: z
        .array(z.object({
        position: z.number().int().min(0).max(LIMITS.sceneMaxCount - 1),
        text: z.string().min(1).max(LIMITS.sceneTextMaxLength),
    }))
        .min(1)
        .max(LIMITS.sceneMaxCount),
});
export const narrationRequestSchema = z.object({
    /** Indicaciones del usuario para la propuesta (tono, público, lo que debe decir). */
    notes: z.string().trim().max(2_000).default(''),
});
export const narrationStatusSchema = z.object({
    status: z.enum(['NONE', 'PENDING', 'RUNNING', 'COMPLETED', 'FAILED', 'CANCELLED']),
    jobId: z.uuid().nullable(),
    script: narrationScriptSchema.nullable(),
    error: z.string().nullable(),
    createdAt: z.string().nullable(),
});
export const saveNarrationRequestSchema = z.object({
    expectedRevision: z.number().int().min(1),
    voiceEnabled: z.boolean().optional(),
    voiceName: ttsVoiceSchema.optional(),
    voiceStyle: z.string().trim().max(300).optional(),
    voiceSpeed: z.number().min(0.5).max(1.5).optional(),
    scenes: z.array(z.object({ sceneId: z.uuid(), text: z.string().max(LIMITS.sceneTextMaxLength).nullable() })).max(LIMITS.sceneMaxCount),
});
export const generateNarrationAudioRequestSchema = z.object({
    expectedRevision: z.number().int().min(1),
    /** true: solo escenas sin voz; false: todas las que tienen texto (regenera). */
    onlyMissing: z.boolean().default(true),
});
/** Frase fija para comparar voces: igual para todas, en el idioma del producto. */
export const VOICE_SAMPLE_TEXT = 'Hola, soy la voz que narrará tu vídeo. Puedo sonar cercana y pausada, o más enérgica, según el estilo que elijas.';
export const voiceSampleRequestSchema = z.object({
    voiceName: ttsVoiceSchema,
    voiceStyle: z.string().trim().max(300).default(''),
    voiceSpeed: z.number().min(0.5).max(1.5).default(1),
});
//# sourceMappingURL=narration.js.map